import { render } from "./ProductItemView.vue?vue&type=template&id=2ac97c1b"
import script from "./ProductItemView.vue?vue&type=script&lang=js"
export * from "./ProductItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__